import { useEffect, useRef } from 'react';
import cls from 'classnames';
import svga from '@widgets/functions/animation/svga';

const SvgaPlayer = (props) => {
  const { url, className, loops = 1, onStop, ...rest } = props;
  const ref = useRef();

  useEffect(() => {
    let player: any = null;
    if (url && ref.current) {
      player = (svga as any).play({
        url,
        onStop,
        loops,
        container: ref.current,
        clearsAfterStop: true,
      });
    }

    return () => {
      if (player?.stopAnimation) {
        player.stopAnimation(true);
      }
    };
  }, [url]);

  if (!url) {
    return null;
  }

  return (
    <div ref={ref} className={cls('svga-player', className)} {...rest}></div>
  );
};

export default SvgaPlayer;
